import React, { useState } from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { BACKEND_URL } from '../config';
import '../css/VinPage.css';

const VinPage = () => {
    const [form, setForm] = useState({ vin: '', partName: '', phone: '' });
    const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'
    const [errorMsg, setErrorMsg] = useState('');

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        setErrorMsg('');
        try {
            const res = await fetch(`${BACKEND_URL}/vin-requests`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });
            if (!res.ok) throw new Error(`Помилка сервера: ${res.status}`);
            setStatus('success');
            setForm({ vin: '', partName: '', phone: '' });
        } catch (err) {
            setStatus('error');
            setErrorMsg(err.message);
        }
    };

    return (
        <Layout>
            <SEO
                title="Підбір запчастин за VIN кодом — Union Auto"
                description="Вкажіть VIN код вашого автомобіля та потрібну деталь — ми підберемо запчастину та передзвонимо."
                canonical="/vin-search"
            />
            <div className="vin-page">

                <div className="vin-page__hero">
                    <span className="vin-page__badge">Безкоштовно</span>
                    <h1 className="vin-page__title">Підбір запчастин за VIN кодом</h1>
                    <p className="vin-page__subtitle">
                        Залиште VIN код вашого автомобіля і назву деталі — наші менеджери підберуть
                        потрібну запчастину та зв'яжуться з вами найближчим часом.
                    </p>
                </div>

                <div className="vin-page__layout">
                    <div className="vin-page__card">
                        {status === 'success' ? (
                            <div className="vin-page__success">
                                <div className="vin-page__success-icon">✓</div>
                                <h2 className="vin-page__success-title">Заявку прийнято!</h2>
                                <p className="vin-page__success-text">
                                    Ми зв'яжемося з вами найближчим часом.
                                </p>
                                <button
                                    className="vin-page__submit"
                                    onClick={() => setStatus(null)}
                                    type="button"
                                >
                                    Подати ще одну заявку
                                </button>
                            </div>
                        ) : (
                            <form className="vin-page__form" onSubmit={handleSubmit} noValidate>
                                <h2 className="vin-page__form-title">Заповніть форму</h2>

                                <div className="vin-page__field">
                                    <label className="vin-page__label" htmlFor="vin">
                                        VIN код <span className="vin-page__required">*</span>
                                    </label>
                                    <input
                                        id="vin"
                                        name="vin"
                                        type="text"
                                        className="vin-page__input"
                                        placeholder="Наприклад: WBA3A5G59DNP26082"
                                        value={form.vin}
                                        onChange={handleChange}
                                        maxLength={17}
                                        required
                                        autoComplete="off"
                                    />
                                    <span className="vin-page__hint">
                                        17 символів — знаходиться на кузові або в техпаспорті
                                    </span>
                                </div>

                                <div className="vin-page__field">
                                    <label className="vin-page__label" htmlFor="partName">
                                        Назва деталі <span className="vin-page__required">*</span>
                                    </label>
                                    <input
                                        id="partName"
                                        name="partName"
                                        type="text"
                                        className="vin-page__input"
                                        placeholder="Наприклад: Головка блоку циліндрів"
                                        value={form.partName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="vin-page__field">
                                    <label className="vin-page__label" htmlFor="phone">
                                        Номер телефону <span className="vin-page__required">*</span>
                                    </label>
                                    <input
                                        id="phone"
                                        name="phone"
                                        type="tel"
                                        className="vin-page__input"
                                        placeholder="+380 XX XXX XX XX"
                                        value={form.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                {status === 'error' && (
                                    <div className="vin-page__error">
                                        {errorMsg || 'Сталася помилка. Спробуйте ще раз.'}
                                    </div>
                                )}

                                <button
                                    type="submit"
                                    className="vin-page__submit"
                                    disabled={status === 'loading'}
                                >
                                    {status === 'loading' ? 'Відправляємо...' : 'Відправити заявку'}
                                </button>
                            </form>
                        )}
                    </div>

                    <div className="vin-page__steps">
                        <h3 className="vin-page__steps-title">Як це працює?</h3>
                        <div className="vin-page__step">
                            <div className="vin-page__step-num">1</div>
                            <div className="vin-page__step-text">
                                <strong>Заповніть форму</strong>
                                <p>Вкажіть VIN код, назву деталі та номер телефону</p>
                            </div>
                        </div>
                        <div className="vin-page__step">
                            <div className="vin-page__step-num">2</div>
                            <div className="vin-page__step-text">
                                <strong>Перевіряємо наявність</strong>
                                <p>Менеджер шукає запчастину точно під ваш автомобіль</p>
                            </div>
                        </div>
                        <div className="vin-page__step">
                            <div className="vin-page__step-num">3</div>
                            <div className="vin-page__step-text">
                                <strong>Передзвонюємо</strong>
                                <p>Повідомляємо ціну та умови доставки по Україні</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </Layout>
    );
};

export default VinPage;
